// removed by extract-text-webpack-plugin
module.exports = {"container":"HeaderConFiltro__container___3D6jc","divTitulo":"HeaderConFiltro__divTitulo___3EwIN","spanOrdenar":"HeaderConFiltro__spanOrdenar___2yI0C","menu":"HeaderConFiltro__menu___nr1GQ","inputTexto":"HeaderConFiltro__inputTexto___2rNoo","contenedorValores":"HeaderConFiltro__contenedorValores___2Q55Q","filtroColoreado":"HeaderConFiltro__filtroColoreado___2gAqi"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/components/shared/HeaderConFiltro.css
// module id = 628
// module chunks = 0